import React from "react";

const NoDataToDisplay = ({ text = "Nincs megjeleníthető adat" }) => {
    return(
        <div className="col-12 mt-3 no-data-to-display">
            <div className="inner">
                <i className="fas fa-house-damage"></i>
                <span>{text}</span>
            </div>
        </div>
    )
}

export default NoDataToDisplay;